export default __webpack_public_path__ + "static/media/argentan4.21fed9e5.jpg";